import React from 'react';
import { BlogPost } from '@/typings/blog';
import * as S from './BlogDetail.styles';
import { IconCalendarEvent, IconUser, IconTag } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { Tag } from '@/typings/tag';
import LandingPageBanner from '@/components/LandingPageBanner/LandingPageBanner';
import TagsSelect from '@/components/TagsSelect/TagsSelect';
import { Title } from '@mantine/core';
import { motion } from 'framer-motion';
import VideoModal from '@/components/VideoModal/VideoModal';
import { useDisclosure } from '@mantine/hooks';
import Image from 'next/image';
import { BsPlayCircle } from 'react-icons/bs';

type BlogDetailProps = {
  blogPost: BlogPost;
  tags: Tag[];
  allTags: Tag[];
  videoUrl: string | null;
};

const BlogDetail: React.FC<BlogDetailProps> = ({ blogPost, tags, allTags, videoUrl }) => {
  const [modalOpened, { close: modalClose, open: modalOpen }] = useDisclosure(false);

  const publishedAt = dayjs(blogPost.publishedAt as Date).format('DD/MM/YYYY');

  const video = blogPost.video;

  // Remove unwanted loading spinners from post
  React.useEffect(() => {
    setTimeout(() => {
      const loadingTags = document.querySelectorAll('.image-uploading');
      if (loadingTags && loadingTags.length > 0) {
        loadingTags.forEach((tag) => {
          tag.classList.add('hidden');
          // Try to hide instead of removing to prevent rehydration errors
          // tag.remove();
        });
      }
    }, 1000);
  }, [blogPost.content]);

  return (
    <S.Wrapper>
      <LandingPageBanner
        title={blogPost.title}
        banner={blogPost.banner}
        isBlogDetail={true}
        description={
          <ul>
            <li>
              <IconCalendarEvent style={{ marginBottom: 3 }} size={24} color="white" />{' '}
              {publishedAt}
            </li>
            <li>
              <IconUser size={24} color="white" /> <span style={{ fontWeight: 400 }}>por: </span>{' '}
              {blogPost.author}
            </li>
            {tags.length > 0 && (
              <li>
                <IconTag color="white" /> {tags.map((tag) => tag.title).join(', ')}
              </li>
            )}
          </ul>
        }
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
          transition: {
            mass: 1,
            delay: 0.2,
            duration: 0.6,
            type: 'tween',
          },
        }}
      >
        <S.Content>
          {videoUrl && video && (
            <div className="video-container">
              <div className="thumbnail">
                <button onClick={modalOpen}>
                  <BsPlayCircle fill="#ffffffc0" size={120} />
                </button>
                <Image src={video.thumbnail || ''} alt="" fill />
              </div>
              <VideoModal
                vertical={video.verticalVideo}
                url={videoUrl}
                opened={modalOpened}
                onClose={modalClose}
              />
            </div>
          )}
          <div className="ql-editor" dangerouslySetInnerHTML={{ __html: blogPost.content }} />
        </S.Content>
      </motion.div>
      {allTags.length > 0 && (
        <div className="tags-container">
          <Title order={2}>Explore outros assuntos</Title>
          <TagsSelect categories={allTags} />
        </div>
      )}
    </S.Wrapper>
  );
};

export default BlogDetail;
